export const keyring_original_product_faces2 = {
  value: [
    {
      debug: {},
      bpf_id: 8963,
      rotate: 0,
      cv_bpcf: {
        cid: 'c9',
        src: '//s3.marpple.co/files/u_193535/2021/10/original/3f954df2e75c31b48474082395620b72e149a1401.png',
        top: 0,
        fill: 'rgb(0,0,0)',
        left: 0,
        type: 'image',
        _data: { cv_type: 'cv_bpcf', nscreened: false, is_not_design: true },
        angle: 0,
        flipX: false,
        flipY: false,
        skewX: 0,
        skewY: 0,
        width: 860,
        alignX: 'none',
        alignY: 'none',
        clipTo: null,
        height: 860,
        scaleX: 1,
        scaleY: 1,
        shadow: null,
        stroke: null,
        evented: false,
        filters: [],
        opacity: 1,
        originX: 'left',
        originY: 'top',
        visible: true,
        fillRule: 'nonzero',
        selectable: false,
        crossOrigin: 'Anonymous',
        meetOrSlice: 'meet',
        strokeWidth: 0,
        resizeFilters: [],
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        backgroundColor: '',
        strokeDashArray: null,
        transformMatrix: null,
        strokeMiterLimit: 10,
        globalCompositeOperation: 'destination-over',
      },
      designs: [
        {
          cid: 'c9898',
          src: '//s3.marpple.co/files/u_193535/2025/1/900/663d32d20a2a2c1654c1f5311f8026bf3ada6c621.png',
          top: 125.75725,
          fill: 'rgb(0,0,0)',
          left: 401.5,
          type: 'image',
          _data: {
            name: '',
            price: 0,
            rotate: 0,
            cv_type: 'cv_image',
            name_en: '',
            name_jp: '',
            is_embro: false,
            price_en: 0,
            price_jp: 0,
            width_cm: 3,
            height_cm: 6.2,
            image_url:
              '//s3.marpple.co/files/u_193535/2025/1/original/663d32d20a2a2c1654c1f5311f8026bf3ada6c621.png',
            nscreened: false,
            hole_position: { x: 0.19, y: 0.987 },
            real_width_cm: 3,
            charm_position: { x: 0.98, y: 0.6237 },
            image_width_cm: 3,
            original_is_ai: null,
            real_height_cm: 6.2,
            image_height_cm: 6.7,
            is_marpple_image: false,
            design_collection_type: null,
          },
          angle: 0,
          flipX: false,
          flipY: false,
          skewX: 0,
          skewY: 0,
          width: 600,
          alignX: 'none',
          alignY: 'none',
          clipTo: null,
          height: 1233,
          scaleX: 0.25,
          scaleY: 0.25,
          shadow: null,
          stroke: null,
          evented: true,
          filters: [],
          opacity: 1,
          originX: 'left',
          originY: 'top',
          visible: true,
          fillRule: 'nonzero',
          selectable: true,
          crossOrigin: 'Anonymous',
          is_overflow: false,
          meetOrSlice: 'meet',
          strokeWidth: 0,
          is_oversized: false,
          is_smallsized: false,
          resizeFilters: [],
          strokeLineCap: 'butt',
          strokeLineJoin: 'miter',
          backgroundColor: '',
          strokeDashArray: null,
          transformMatrix: null,
          strokeMiterLimit: 10,
          globalCompositeOperation: 'source-over',
        },
        {
          cid: 'c2323',
          src: '//s3.marpple.co/files/u_4433125/2025/1/900/03a768124ccc76bf274c997e5fb7324977efc5791',
          top: 407.17867634594614,
          fill: 'rgb(0,0,0)',
          left: 360.0521095334685,
          type: 'image',
          _data: {
            name: '',
            price: 100,
            rotate: 0,
            cv_type: 'cv_image',
            name_en: '',
            image_id: 16600381,
            is_embro: false,
            price_en: 0.55,
            price_jp: 59,
            width_cm: 2.9,
            height_cm: 4.7,
            image_url:
              '//s3.marpple.co/files/u_4433125/2025/1/original/03a768124ccc76bf274c997e5fb7324977efc5791',
            nscreened: false,
            only_flex: false,
            fitted_size: { width: 28, height: 48 },
            image_width: 443,
            image_height: 731,
            hole_position: { x: 0.48645598194130923, y: 0.09618251003036865 },
            real_width_cm: 2.9,
            image_color_id: null,
            image_width_cm: 2.875815821501014,
            original_is_ai: false,
            press_color_id: null,
            real_height_cm: 4.7,
            image_height_cm: 4.745420689655172,
            is_marpple_image: false,
            press_color_code: null,
            press_color_name: null,
            image_original_url: null,
            design_collection_type: null,
          },
          angle: 0,
          flipX: false,
          flipY: false,
          skewX: 0,
          skewY: 0,
          width: 443,
          alignX: 'none',
          alignY: 'none',
          clipTo: null,
          height: 731,
          scaleX: 0.3245841784989858,
          scaleY: 0.3245841784989858,
          shadow: null,
          stroke: null,
          evented: true,
          filters: [],
          opacity: 1,
          originX: 'left',
          originY: 'top',
          visible: true,
          fillRule: 'nonzero',
          selectable: true,
          crossOrigin: 'Anonymous',
          is_overflow: false,
          meetOrSlice: 'meet',
          strokeWidth: 0,
          is_oversized: false,
          is_smallsized: false,
          resizeFilters: [],
          strokeLineCap: 'butt',
          strokeLineJoin: 'miter',
          backgroundColor: '',
          strokeDashArray: null,
          transformMatrix: null,
          strokeMiterLimit: 10,
          globalCompositeOperation: 'source-over',
        },
        {
          cid: 'c8888',
          src: '//s3.marpple.co/files/u_193535/2025/1/900/c2e516394b66063e9373ae7f13611140540f452e1.png',
          top: 125.75725,
          fill: 'rgb(0,0,0)',
          left: 401.5,
          type: 'image',
          _data: {
            name: '',
            price: 0,
            rotate: 0,
            cv_type: 'cv_image',
            name_en: '',
            name_jp: '',
            is_embro: false,
            price_en: 0,
            price_jp: 0,
            width_cm: 3,
            height_cm: 6.2,
            image_url:
              '//s3.marpple.co/files/u_193535/2025/1/original/c2e516394b66063e9373ae7f13611140540f452e1.png',
            nscreened: false,
            hole_position: { x: 0.19, y: 0.987 },
            real_width_cm: 3,
            charm_position: { x: 0.98, y: 0.6237 },
            image_width_cm: 3,
            original_is_ai: null,
            real_height_cm: 6.2,
            image_height_cm: 6.7,
            is_marpple_image: false,
            design_collection_type: null,
          },
          angle: 0,
          flipX: false,
          flipY: false,
          skewX: 0,
          skewY: 0,
          width: 600,
          alignX: 'none',
          alignY: 'none',
          clipTo: null,
          height: 1233,
          scaleX: 0.25,
          scaleY: 0.25,
          shadow: null,
          stroke: null,
          evented: true,
          filters: [],
          opacity: 1,
          originX: 'left',
          originY: 'top',
          visible: true,
          fillRule: 'nonzero',
          selectable: true,
          crossOrigin: 'Anonymous',
          is_overflow: false,
          meetOrSlice: 'meet',
          strokeWidth: 0,
          is_oversized: false,
          is_smallsized: false,
          resizeFilters: [],
          strokeLineCap: 'butt',
          strokeLineJoin: 'miter',
          backgroundColor: '',
          strokeDashArray: null,
          transformMatrix: null,
          strokeMiterLimit: 10,
          globalCompositeOperation: 'source-over',
        },
      ],
      cv_mask1: {
        cid: 'c10',
        src: '//s3.marpple.co/files/u_193535/2021/10/original/84d28a77f3583b699cfa2e4cb1fa2ac161070ad31.png',
        top: 0,
        fill: 'rgb(0,0,0)',
        left: 0,
        type: 'image',
        _data: { cv_type: 'cv_mask1', nscreened: false, is_not_design: true },
        angle: 0,
        flipX: false,
        flipY: false,
        skewX: 0,
        skewY: 0,
        width: 860,
        alignX: 'none',
        alignY: 'none',
        clipTo: null,
        height: 860,
        scaleX: 1,
        scaleY: 1,
        shadow: null,
        stroke: null,
        evented: false,
        filters: [],
        opacity: 1,
        originX: 'left',
        originY: 'top',
        visible: true,
        fillRule: 'nonzero',
        selectable: false,
        crossOrigin: 'Anonymous',
        meetOrSlice: 'meet',
        strokeWidth: 0,
        resizeFilters: [],
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        backgroundColor: '',
        strokeDashArray: null,
        transformMatrix: null,
        strokeMiterLimit: 10,
        globalCompositeOperation: 'destination-in',
      },
      cv_mask2: {
        cid: 'c11',
        src: '',
        top: 0,
        fill: 'rgb(0,0,0)',
        left: 0,
        type: 'image',
        _data: { cv_type: 'cv_mask2', is_not_design: true },
        angle: 0,
        flipX: false,
        flipY: false,
        skewX: 0,
        skewY: 0,
        width: 0,
        alignX: 'none',
        alignY: 'none',
        clipTo: null,
        height: 0,
        scaleX: 1,
        scaleY: 1,
        shadow: null,
        stroke: null,
        evented: false,
        filters: [],
        opacity: 1,
        originX: 'left',
        originY: 'top',
        visible: false,
        fillRule: 'nonzero',
        selectable: false,
        crossOrigin: 'Anonymous',
        meetOrSlice: 'meet',
        strokeWidth: 0,
        resizeFilters: [],
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        backgroundColor: '',
        strokeDashArray: null,
        transformMatrix: null,
        strokeMiterLimit: 10,
        globalCompositeOperation: 'destination-in',
      },
      face_name: '앞면',
      size_info: {
        top: 132.0668604651163,
        left: 378.8372093023256,
        right: 324.64244186046517,
        width: 201.52034883720933,
        bottom: 226.7761627906977,
        height: 546.1569767441861,
        x_diff: -27.097383720930225,
        y_diff: 47.3546511627907,
      },
      cv_shading: {
        cid: 'c12',
        src: '',
        top: 0,
        fill: 'rgb(0,0,0)',
        left: 0,
        type: 'image',
        _data: { cv_type: 'cv_shading', nscreened: false, is_not_design: true },
        angle: 0,
        flipX: false,
        flipY: false,
        skewX: 0,
        skewY: 0,
        width: 860,
        alignX: 'none',
        alignY: 'none',
        clipTo: null,
        height: 860,
        scaleX: 1,
        scaleY: 1,
        shadow: null,
        stroke: null,
        evented: false,
        filters: [],
        opacity: 1,
        originX: 'left',
        originY: 'top',
        visible: false,
        fillRule: 'nonzero',
        selectable: false,
        crossOrigin: 'Anonymous',
        meetOrSlice: 'meet',
        strokeWidth: 0,
        resizeFilters: [],
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        backgroundColor: '',
        strokeDashArray: null,
        transformMatrix: null,
        strokeMiterLimit: 10,
        globalCompositeOperation: 'source-over',
      },
      size_faces: [
        {
          dpi: 300,
          img: { diff: 0, width: 860, height: 860 },
          line: { top: 0, left: 0, width: 0, height: 0 },
          real: {
            cm: { width: 19, height: 19 },
            px: { top: 0, left: 31, width: 798, height: 798, scaleX: 1, scaleY: 1 },
          },
          mask2: { other_height: 0 },
          print: {
            cm: { width: 19, height: 19 },
            px: { rx: 0, ry: 0, top: 0, left: 31, width: 798, height: 798, scaleX: 1, scaleY: 1 },
            etc_meta: { hole_position: { x: 430, y: 430 } },
            hole_position: { x: 430, y: 430 },
          },
          px_per_1cm: 50,
          is_standard: false,
          end_point_cm: 0,
          start_point_cm: 0,
          base_product_size_id: 9936,
          is_print_area_legacy: false,
        },
      ],
      start_name: '',
      collabo_type: 'creator',
      face_name_en: 'Front',
      face_name_jp: '前面',
      preview_data: null,
      cv_print_area: {
        rx: 0,
        ry: 0,
        cid: 'c14',
        top: -2,
        fill: 'rgba(0,0,0,0)',
        left: 29,
        type: 'rect',
        _data: {
          cv_type: 'cv_print_area',
          print_px: { rx: 0, ry: 0, top: 0, left: 31, width: 798, height: 798, scaleX: 1, scaleY: 1 },
          nscreened: false,
          is_not_design: true,
        },
        angle: 0,
        flipX: false,
        flipY: false,
        skewX: 0,
        skewY: 0,
        width: 800,
        clipTo: null,
        height: 800,
        scaleX: 1,
        scaleY: 1,
        shadow: null,
        stroke: '#2f2f2f',
        evented: false,
        opacity: 1,
        originX: 'left',
        originY: 'top',
        visible: false,
        fillRule: 'nonzero',
        selectable: false,
        strokeWidth: 2,
        strokeLineCap: 'butt',
        strokeLineJoin: 'miter',
        backgroundColor: '',
        strokeDashArray: [6, 3],
        transformMatrix: null,
        strokeMiterLimit: 10,
        globalCompositeOperation: 'source-over',
      },
      printable_files: [],
      is_design_over_bpf: false,
      base_product_size_id: false,
      bpf_mask2_padding_top: 0,
      is_enable_loc_optimization: false,
      is_activate_loc_optimization: false,
      is_cs_requested_loc_optimization: false,
      is_proof_of_seen_loc_optimization: false,
    },
  ],
  can_not_change_color: false,
};
